import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { fmtIDR } from "../lib/api";
import { fmtUSD } from "../lib/currency";

function Line({ label, value, testId, strong }) {
  return (
    <div className="flex justify-between text-xs py-0.5"><span className="text-[#A8A8AD]">{label}</span>
      <span data-testid={testId} className={strong ? "text-[#D4AF37] font-bold text-sm" : "text-[#F5F3ED]"}>{value}</span></div>
  );
}

export default function PayPalPanel({ o, isBuyer, reload }) {
  const [params, setParams] = useSearchParams();
  const [busy, setBusy] = useState(false);
  const handled = useRef(false);

  useEffect(() => {
    const flag = params.get("paypal");
    if (!flag || handled.current || !isBuyer) return;
    handled.current = true;
    setParams({}, { replace: true });
    if (flag === "cancel") { toast.info("Pembayaran PayPal dibatalkan. Anda bisa mencoba lagi sebelum batas waktu."); return; }
    setBusy(true);
    api.post(`/orders/${o.id}/paypal/capture`)
      .then(() => { toast.success("Pembayaran PayPal terverifikasi. Pesanan sedang disiapkan."); reload(); })
      .catch((e) => toast.error(e?.response?.data?.detail || "Verifikasi PayPal gagal"))
      .finally(() => setBusy(false));
  }, [params]); // eslint-disable-line react-hooks/exhaustive-deps

  const pay = async () => {
    setBusy(true);
    try { const r = await api.post(`/orders/${o.id}/paypal/create`); window.location.assign(r.data.approve_url); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal membuka PayPal"); setBusy(false); }
  };
  const pp = o.paypal || {};
  return (
    <div data-testid="paypal-panel" className="border border-[#D4AF37]/30 rounded-sm p-3 mb-3">
      <Line label="Subtotal" value={fmtIDR(o.subtotal_idr ?? o.total_idr)} testId="pp-subtotal" />
      {o.balance_used_idr > 0 && <Line label="Saldo Store" value={`- ${fmtIDR(o.balance_used_idr)}`} />}
      <Line label={`Biaya PayPal ${o.payment_fee_percent}%`} value={fmtIDR(o.payment_fee_idr)} testId="pp-fee" />
      <Line label="Total (IDR)" value={fmtIDR(o.amount_due_idr)} testId="pp-total-idr" />
      <Line label="Dibayar via PayPal" value={o.amount_due_usd != null ? fmtUSD(o.amount_due_usd) : "-"} testId="pp-total-usd" strong />
      {o.fx_rate && <div className="text-[10px] text-[#A8A8AD] text-right">Kurs $1 = {fmtIDR(o.fx_rate)}</div>}
      {pp.capture_id && <div data-testid="pp-verified" className="mt-2 text-xs text-[#35C78A]">Terverifikasi PayPal · {pp.capture_id}</div>}
      {isBuyer && o.status === "waiting_payment" && o.paypal_auto && (
        <button data-testid="paypal-pay-btn" onClick={pay} disabled={busy}
          className="mt-3 w-full rounded-full py-2.5 font-bold text-sm bg-[#FFC439] hover:bg-[#f2b72c] text-[#111] disabled:opacity-50 transition-colors">
          {busy ? "Memproses..." : "Bayar dengan PayPal"}
        </button>
      )}
      {o.status === "waiting_payment" && !o.paypal_auto && <div data-testid="pp-manual-note" className="mt-2 text-[11px] text-[#F2D98D]">Verifikasi manual: kirim tepat {o.amount_due_usd != null ? fmtUSD(o.amount_due_usd) : ""} lalu unggah bukti. Status berubah setelah Admin memverifikasi.</div>}
      {pp.last_error && o.status === "waiting_payment" && <div className="mt-2 text-[11px] text-[#F06464]">{pp.last_error}</div>}
    </div>
  );
}
